import { render } from "./IndividualDetail.vue?vue&type=template&id=42302a59&scoped=true"
import script from "./IndividualDetail.vue?vue&type=script&lang=js"
export * from "./IndividualDetail.vue?vue&type=script&lang=js"

import "./IndividualDetail.vue?vue&type=style&index=0&id=42302a59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42302a59"]])

export default __exports__